import React from 'react';
import Ceremony from './Ceremony';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

const OuterSetupCeremony = () => {
    const RegisterButton = (
        <Link to="/outer-setup">
            <Button type="primary" size="large" disabled>
                Contribute
            </Button>
        </Link>
    );

    return (
        <Ceremony
            title="Outer Setup"
            description={
                <span>
                    The Outer Setup has ended. Please participate in the Inner Setup if you would like to contribute.
                </span>
            }
            button={RegisterButton}
        />
    );
};

export default OuterSetupCeremony;
